import { render, staticRenderFns } from "./editFormData.vue?vue&type=template&id=ad9f8afc&"
import script from "./editFormData.vue?vue&type=script&lang=js&"
export * from "./editFormData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports